module.exports = __webpack_public_path__ + "img/临床研究实验室.43cea62b.png";